
import {
  deletePostApi,
  editPostApi,
  getPostDetailApi,
} from "../../../../callApi/postApi";
import CustomHeader from "../../../../components/admin/CustomHeader";
import CustomLeftBar from "../../../../components/admin/CustomLeftBar";
import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import CustomButton from "../../../../components/CustomButton";
import Notiflix from "notiflix";
import parse from "html-react-parser";
import CustomHtmlEditor from "../../../../components/CustomHtmlEditor";
import { editProductApi } from "../../../../callApi/productApi";
import CustomInputProduct from "../../../../components/CustomInputProduct";
import { DeleteImgApi, UploadImgApi } from "../../../../callApi/upload";
import { useNavigate, useParams } from "react-router-dom";

export default function AdminPostID() {
  const router = useNavigate();
  const params = useParams();
  const [postItem, setpostItem] = useState("");
  const [postContent, setpostContent] = useState(null);
  const [SelectType, setSelectType] = useState(1);
  const [htmlEditorArray, sethtmlEditorArray] = useState([]);
  const [title, settitle] = useState("");
  const [post_categories, setpost_categories] = useState(null);

  useEffect(() => {
    if (params.id != null) {
      callpost();
    }
  }, [params]);

  const saveData = async () => {
    // compare data
    try {
      if (post_categories != null) {
        Notiflix.Loading.circle();
        let tempHtml = [];
        let error = null;
        for (let i = 0; i < postContent.length; i++) {
          if (i < htmlEditorArray.length) {
            for (let j = 0; j < postContent[i].length; j++) {
              if (j < htmlEditorArray[i].length) {
                if (postContent[i][j].type == "image") {
                  // console.log("in scope");
                  if (postContent[i][j].value == htmlEditorArray[i][j].value) {
                    // console.log("equare");
                  } else {
                    // console.log("not equare");
                    let tempNameDelete = postContent[i][j].value.split(".");
                    // console.log('tempNameDelete',tempNameDelete[0])
                    const res = await DeleteImgApi({ name: tempNameDelete[0] });
                  }
                }
              } else {
                // console.log("out scope");
                break;
              }
            }
          } else {
            break;
          }
        }
        for (let i = 0; i < htmlEditorArray.length; i++) {
          let tempHtmlArray = [];
          for (let j = 0; j < htmlEditorArray[i].length; j++) {
            if (
              htmlEditorArray[i][j].value != "" ||
              htmlEditorArray[i][j].value != null ||
              htmlEditorArray[i][j].value != undefined
            ) {
              if (htmlEditorArray[i][j].type == "image") {
                if (htmlEditorArray[i][j].path) {
                  const res = await UploadImgApi({
                    file: htmlEditorArray[i][j].value,
                  });
                  if (res.status == 200 || res.status == 201) {
                    tempHtmlArray.push({
                      type: htmlEditorArray[i][j].type,
                      value: res.data.data.img,
                    });
                  }
                } else {
                  tempHtmlArray.push({
                    type: htmlEditorArray[i][j].type,
                    value: htmlEditorArray[i][j].value,
                  });
                }
              } else {
                tempHtmlArray.push({
                  type: htmlEditorArray[i][j].type,
                  value: htmlEditorArray[i][j].value,
                });
              }
            } else {
              error = "กรุณาใส่ข้อมูลให้ครบถ้วน";
              break;
            }
          }
          tempHtml.push(tempHtmlArray);
          if (error != null) {
            break;
          }
        }
        if (error != null) {
          Notiflix.Notify.warning(error);
          return;
        }
        const html = JSON.stringify({ html: tempHtml });
        console.log("html", html);
        const res = await editPostApi({
          post_id: params.id,
          content: html,
          title: title,
          post_categories_id: post_categories.id,
        });
        Notiflix.Loading.remove();
        if (res.status == 200) {
          Notiflix.Notify.success("Success");
          // router(-1);
          // setSelectType(1);
          // callpost;
          router(-1);
        } else {
          Notiflix.Notify.failure("Error");
        }
      } else {
        Notiflix.Notify.warning("กรุณาเลือกประเภท");
      }
    } catch (error) {
      console.log("error", error);

      Notiflix.Loading.remove();
      Notiflix.Notify.failure("Error");
    }
  };

  const callpost = async () => {
    let res = await getPostDetailApi({ post_id: params.id });
    if (res?.status == 200) {
      setpostItem(res.data.data);
      let parseContent = JSON.parse(res.data.data.content).html;
      setpostContent(parseContent);
      settitle(res.data.data.title);
      let tempPostCategories =
        res.data.data.post_categories_id == 1
          ? { name: "News&Event", id: 1 }
          : res.data.data.post_categories_id == 2
          ? { name: "Knowledge", id: 2 }
          : null;
      setpost_categories(tempPostCategories);
    }
  };

  const deletepost = async () => {
    const res = await deletePostApi({ post_id: params.id });
    if (res?.status == 200) {
      for (let i = 0; i < postContent.length; i++) {
        for (let j = 0; j < postContent[i].length; j++) {
          if (postContent[i][j].type == "image") {
            let tempNameDelete = postContent[i][j].value.split(".");
            // console.log('tempNameDelete',tempNameDelete[0])
            const resDelete = await DeleteImgApi({ name: tempNameDelete[0] });
          }
        }
      }
      Notiflix.Notify.success("สำเร็จ");
      router(-1);
    }
  };
  const PreviewContent = () => {
    return (
      <div className="my-5 w-full">
        <p className=" text-[24px] w-full font-semibold text-center">
          {postItem.title}
        </p>
        {postContent?.map((item, i) => {
          return (
            <div key={i} className="grid grid-flow-col gap-3 w-full">
              {item?.map((data, j) => {
                if (data.type == "text")
                  return (
                    <div
                      key={j}
                      className="rounded-lg py-2 bg-white drop-shadow-sm w-full"
                      // dangerouslySetInnerHTML={{ __html: data.value }}
                    >
                      {parse(data.value)}
                    </div>
                  );
                if (data.type == "image")
                  return (
                    <div key={j} className="flex-1 flex flex-col items-center">
                      <img
                        src={
                          // "https://upload.wikimedia.org/wikipedia/en/thumb/e/e2/IMG_Academy_Logo.svg/800px-IMG_Academy_Logo.svg.png"
                          "https://ftcdc.udru.ac.th/ftcdc-api/storage/app/public/upload/UploadImg/" +
                          data.value
                        }
                        className="object-cover rounded-lg"
                      />
                    </div>
                  );
                return <div className="flex-1"></div>;
              })}
            </div>
          );
        })}
      </div>
    );
  };
  const EditContent = () => {
    return (
      <div className=" my-5 flex flex-col gap-3 ">
        <div className="w-full flex flex-row gap-4 z-10">
          <CustomInputProduct
            value={post_categories}
            onChange={(v) => setpost_categories(v)}
            title="ประเภท"
            placeHolder="กรุณาเลือกประเภท"
            fontSize={14}
            type={"select"}
            data={[
              { name: "News&Event", id: 1 },
              { name: "Knowledge", id: 2 },
            ]}
          />
          <CustomInputProduct
            value={title}
            onChange={(v) => settitle(v)}
            title="ชื่อเรื่อง"
            placeHolder="กรุณาใส่ชื่อเรื่อง"
            fontSize={14}
          />
        </div>
        <div className="overflow-x-auto w-full flex-[1] h-full">
          <CustomHtmlEditor
            initial={postContent}
            onChange={sethtmlEditorArray}
          />
        </div>

        <div className=" flex flex-row gap-3 my-6 justify-center items-center">
          <CustomButton
            leftIconName={"uil:save"}
            txt={"Save"}
            bgcolor="#2271B1"
            onClick={() => {
              saveData();
            }}
          />
          <CustomButton
            txt={"Cancel"}
            bgcolor="#9E0400"
            onClick={() => {
              router(-1);
            }}
          />
        </div>
      </div>
    );
  };
  return (
    <div className="flex flex-col h-screen">
      <CustomHeader />
      <div className="flex flex-row flex-[1] overflow-hidden">
        <CustomLeftBar page="Posts" subPage="Add New Post" />
        <div className="p-8 flex flex-col items-center flex-[1] overflow-y-scroll">
          <div className="grid grid-cols-2 w-72 self-center cursor-pointer border rounded-xl drop-shadow-lg bg-white relative">
            <div
              className={
                "text-center hover:opacity-80 active:opacity-50 rounded-l-xl py-1 " +
                (SelectType == 1 ? "bg-admin-primary text-white " : "")
              }
              onClick={() => {
                setSelectType(1);
                callpost();
              }}
            >
              Preview
            </div>
            <div
              className={
                "text-center hover:opacity-80 active:opacity-50 rounded-r-xl py-1  " +
                (SelectType == 2 ? "bg-admin-primary text-white " : "")
              }
              onClick={() => {
                setSelectType(2);
                sethtmlEditorArray(postContent);
              }}
            >
              Edit
            </div>
          </div>
          <div className="absolute right-8 z-[999]">
            <CustomButton
              txt={"ลบ"}
              bgcolor="#9E0400"
              onClick={() => {
                Notiflix.Confirm.show(
                  "ยืนยันการทำรายการ",
                  "คุณต้องการลบโพสนี้ใช่หรือไม่ ? ",
                  "ยืนยัน",
                  "ยกเลิก",
                  () => {
                    deletepost();
                  },
                  () => {},
                  {
                    titleColor: "#9E0400",
                    okButtonBackground: "#9E0400",
                  }
                );
              }}
            />
          </div>
          {SelectType == 1 ? PreviewContent() : null}
          {SelectType == 2 ? EditContent() : null}
        </div>
      </div>
    </div>
  );
}
